/**
 * TalepKaynagi.jsx — the badge that says who entered a request (backlog #462, 2026-10-20; backend #454): Exhibitor / Stand builder / Organiser / SAKA staff, with the
 * company's name next to it (`kisa` keeps only the word, the name goes to the tooltip: for a table cell), and "Unknown" for a request from before the source
 * was recorded (`kaynak` null). The values and the rule are talepKaynagi.js.
 *
 * Shared by the organizer's request list, the stand request page (company / organizer side) and the staff stand detail, so the four words and their colours
 * are the same everywhere. The words are the ones of the list filter (organizator.talepFiltre.kaynaklar).
 */
import React from "react";
import { Badge } from "reactstrap";
import { useTranslation } from "react-i18next";
import { kaynakGecerli } from "./talepKaynaklari";

const RENK = { KATILIMCI: "info", DEKORATOR: "primary", ORGANIZATOR: "warning", PERSONEL: "secondary" };

export default function TalepKaynagi({ kaynak, firmaAdi, kisa = false, className = "" }) {
  const { t } = useTranslation("portal");
  const bilinen = kaynakGecerli(kaynak);
  const ad = bilinen ? t(`organizator.talepFiltre.kaynaklar.${kaynak}`) : t("organizator.talepFiltre.kaynakBilinmiyor");
  const firma = bilinen && firmaAdi ? firmaAdi : null;
  const ipucu = !bilinen
    ? t("organizator.talepFiltre.kaynakBilinmiyorIpucu")
    : firma ? t("organizator.talepFiltre.kaynakIpucu", { kaynak: ad, firma }) : ad;
  return (
    <Badge
      color={bilinen ? RENK[kaynak] : "light"} className={`fw-normal ${bilinen ? "" : "text-muted border"} ${className}`.trim()}
      title={ipucu} data-testid="talep-kaynagi" data-kaynak={bilinen ? kaynak : "BILINMIYOR"}
    >
      {ad}{firma && !kisa ? ` · ${firma}` : ""}
    </Badge>
  );
}
